const REACTION_PLACEHOLDERS = [
  ["{user}", "actorLabel"],
  ["{actor}", "actorLabel"],
  ["{reaction}", "reactionCode"],
  ["{emoji}", "reactionCode"],
  ["{code}", "reactionCode"],
  ["{message}", "messageText"],
  ["{0}", "reactionCode"],
  ["{1}", "messageText"],
];

const normalizeLang = (lang = "en") =>
  String(lang || "en").toLowerCase().startsWith("es") ? "es" : "en";

const hasKnownPlaceholder = (template = "") =>
  REACTION_PLACEHOLDERS.some(([placeholder]) => template.includes(placeholder)) ||
  /%\d*\$?s/.test(template);

const fillTemplate = (template = "", values = {}) => {
  let nextTemplate = String(template || "");

  REACTION_PLACEHOLDERS.forEach(([placeholder, valueKey]) => {
    nextTemplate = nextTemplate.split(placeholder).join(values[valueKey] || "");
  });

  const sequentialValues = [
    values.actorLabel || "",
    values.reactionCode || "",
    values.messageText || "",
  ];
  let sequentialIndex = 0;

  return nextTemplate.replace(/%\d*\$?s/g, () => {
    const value = sequentialValues[sequentialIndex] || "";
    sequentialIndex += 1;
    return value;
  });
};

export const getReactionTargetText = (afterCode = "") =>
  String(afterCode || "")
    .replace(/^\s*(to|a|al|para|en)\s+/i, "")
    .replace(/^\s*(your own message|your message|tu propio mensaje|tu mensaje)\s*/i, "")
    .replace(/^["“”']+|["“”']+$/g, "")
    .trim();

export const formatChatReactionPreviewText = ({
  reactionCode,
  messageText = "",
  actorLabel = "",
  texts = {},
  lang = "en",
} = {}) => {
  const normalizedLang = normalizeLang(lang);
  const normalizedReactionCode = String(reactionCode || "").trim();
  const normalizedMessageText = String(messageText || "").trim();
  const normalizedActorLabel = String(actorLabel || "").trim();
  const bodyTemplate = texts?.LB1155;
  const titleTemplate = texts?.LB1156;
  const fallbackTitle =
    normalizedLang === "es"
      ? normalizedActorLabel
        ? `${normalizedActorLabel} reacciono`
        : "Reaccionaste"
      : normalizedActorLabel
        ? `${normalizedActorLabel} reacted`
        : "You reacted";
  const fallbackConnector = normalizedLang === "es" ? "a" : "to";
  const values = {
    actorLabel: normalizedActorLabel,
    reactionCode: normalizedReactionCode,
    messageText:
      normalizedMessageText ||
      (normalizedLang === "es" ? "un mensaje" : "a message"),
  };

  if (bodyTemplate && hasKnownPlaceholder(bodyTemplate)) {
    return fillTemplate(bodyTemplate, values).trim();
  }

  const title = titleTemplate && hasKnownPlaceholder(titleTemplate)
    ? fillTemplate(titleTemplate, values)
    : titleTemplate || fallbackTitle;
  const connector = bodyTemplate || fallbackConnector;

  return [title, normalizedReactionCode, connector, values.messageText]
    .filter(Boolean)
    .join(" ")
    .trim();
};

export const formatParsedReactionPreview = ({
  parsedReaction,
  texts = {},
  lang = "en",
  actorLabel = "",
} = {}) => {
  if (!parsedReaction?.reactionCode) {
    return null;
  }

  const formattedText = formatChatReactionPreviewText({
    reactionCode: parsedReaction.reactionCode,
    messageText: getReactionTargetText(parsedReaction.afterCode),
    actorLabel,
    texts,
    lang,
  });
  const [beforeCode, afterCode = ""] = formattedText.split(
    parsedReaction.reactionCode,
  );

  return {
    ...parsedReaction,
    beforeCode,
    afterCode,
  };
};
